import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Styles from "./DashboardTotalCustomer.module.css";
import { getAllActiveCustomerAction } from "../../../../store/actions/dashboard/DashboardActions";
import { useNavigate } from "react-router-dom";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";

const DashboardTotalCustomer = React.memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { active_customer, loading, error } = useSelector((state) => state.dashBoardTotalActiveUser);
  useEffect(() => {
    dispatch(getAllActiveCustomerAction({}, navigate));
  }, [dispatch]);

  if (loading) {
    return (
      <>
        <ShimmerLoader width='20%' height='5%' count={1} />
      </>
    );
  }
  if (!loading && active_customer) {
    return (
      <>
        <div className='d-flex align-items-center border-0 px-3'>
          <div className='rounded-circle bg-primary d-flex  align-items-center justify-content-center' style={{ height: "48px", width: "48px" }}>
            <svg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M4.66659 26.8334V24.5H23.3333V26.8334H4.66659ZM4.66659 3.50002V1.16669H23.3333V3.50002H4.66659ZM13.9999 15.1667C14.9721 15.1667 15.7985 14.8264 16.4791 14.1459C17.1596 13.4653 17.4999 12.6389 17.4999 11.6667C17.4999 10.6945 17.1596 9.86808 16.4791 9.18752C15.7985 8.50696 14.9721 8.16669 13.9999 8.16669C13.0277 8.16669 12.2013 8.50696 11.5208 9.18752C10.8402 9.86808 10.4999 10.6945 10.4999 11.6667C10.4999 12.6389 10.8402 13.4653 11.5208 14.1459C12.2013 14.8264 13.0277 15.1667 13.9999 15.1667ZM4.66659 23.3334C4.02492 23.3334 3.47561 23.1049 3.01867 22.6479C2.56172 22.191 2.33325 21.6417 2.33325 21V7.00002C2.33325 6.35835 2.56172 5.80905 3.01867 5.3521C3.47561 4.89516 4.02492 4.66669 4.66659 4.66669H23.3333C23.9749 4.66669 24.5242 4.89516 24.9812 5.3521C25.4381 5.80905 25.6666 6.35835 25.6666 7.00002V21C25.6666 21.6417 25.4381 22.191 24.9812 22.6479C24.5242 23.1049 23.9749 23.3334 23.3333 23.3334H4.66659ZM6.70825 21C7.58325 19.9111 8.64297 19.0556 9.88742 18.4334C11.1319 17.8111 12.5027 17.5 13.9999 17.5C15.4971 17.5 16.868 17.8111 18.1124 18.4334C19.3569 19.0556 20.4166 19.9111 21.2916 21H23.3333V7.00002H4.66659V21H6.70825ZM10.1499 21H17.8499C17.286 20.6111 16.6784 20.3195 16.027 20.125C15.3756 19.9306 14.6999 19.8334 13.9999 19.8334C13.2999 19.8334 12.6242 19.9306 11.9728 20.125C11.3214 20.3195 10.7138 20.6111 10.1499 21ZM13.9999 12.8334C13.6694 12.8334 13.3923 12.7215 13.1687 12.4979C12.9451 12.2743 12.8333 11.9972 12.8333 11.6667C12.8333 11.3361 12.9451 11.059 13.1687 10.8354C13.3923 10.6118 13.6694 10.5 13.9999 10.5C14.3305 10.5 14.6076 10.6118 14.8312 10.8354C15.0548 11.059 15.1666 11.3361 15.1666 11.6667C15.1666 11.9972 15.0548 12.2743 14.8312 12.4979C14.6076 12.7215 14.3305 12.8334 13.9999 12.8334Z' fill='#F6F6F6' />
            </svg>
          </div>

          <div className={`${Styles.statistics_number} d-block py-3 ps-4 align-items-center justify-content-center`}>
            <p>Active Customers</p>
            <p className='text-primary fs-4'>{active_customer.active_customer}</p>
          </div>
        </div>
      </>
    );
  }
});

export default DashboardTotalCustomer;
